import api from './api';

export const validateUsername = (username, config) => {
    let errors = [];
    if (!username) {
        errors.push('username');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/ValidateUsername/${username}`, config);
    }
}

export const fetchTwitterProfile = (username, config) => {
    let errors = [];
    if (!username) {
        errors.push('username');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/FetchTwitterProfile/${encodeURIComponent(username)}`, config);
    }
}

export const validateYoutubeVideo = (username, config) => {
    let errors = [];
    if (!username) {
        errors.push('username');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/ValidateYoutubeVideo/${encodeURIComponent(username)}`, config);
    }
}

export const validateTikTokUsername = (username, config) => {
    let errors = [];
    if (!username) {
        errors.push('username');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Social/ValidateTikTokUsername/${encodeURIComponent(username)}`, config);
    }
}
